// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3B3vi","left":"StickyBox_left__3OcKW","right":"StickyBox_right__2Filv"};